import { render, staticRenderFns } from "./presentacion.vue?vue&type=template&id=437e0e84&"
import script from "./presentacion.vue?vue&type=script&lang=js&"
export * from "./presentacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports